export default "__VITE_ASSET__DuTxa2uY__"